module.exports = __webpack_public_path__ + "img/03_sub_uk.9fa96ab2.svg";